import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTaskSchema } from './shapes';

/** Manual link by raw Task ID or Custom Task ID. */
export const linkPlanTask = defineEndpoint({
  method: 'POST',
  path: '/v1/release-plans/:planId/tasks',
  params: z.object({ planId: z.string().uuid() }),
  query: z.object({}),
  body: z.object({ ref: z.string().trim().min(1).max(64) }),
  response: z.object({ data: PlanTaskSchema }),
  successStatus: 201,
});
